/**
 * Disclosure widgets: FAQ accordion and mobile sub-menus.
 *
 * The expand/collapse animation is pure CSS (see `.bf-collapse`), so this only
 * has to flip `aria-expanded` — no height measuring, no timing to get wrong,
 * and it degrades to an instant toggle if the stylesheet hasn't loaded.
 */

/**
 * Wire one trigger to its panel.
 *
 * @param {HTMLElement} button Trigger with aria-controls.
 * @param {boolean}     single Close sibling panels within the same group.
 */
function bind( button, single ) {
	const panel = document.getElementById( button.getAttribute( 'aria-controls' ) );

	if ( ! panel ) {
		return;
	}

	const setState = ( open ) => {
		button.setAttribute( 'aria-expanded', open ? 'true' : 'false' );
		panel.classList.toggle( 'is-open', open );
	};

	button.addEventListener( 'click', () => {
		const isOpen = 'true' === button.getAttribute( 'aria-expanded' );

		// Accordions show one answer at a time.
		if ( single && ! isOpen ) {
			const group = button.closest( '[data-accordion]' );

			group?.querySelectorAll( '[data-accordion-toggle][aria-expanded="true"]' ).forEach( ( other ) => {
				other.setAttribute( 'aria-expanded', 'false' );
				document.getElementById( other.getAttribute( 'aria-controls' ) )?.classList.remove( 'is-open' );
			} );
		}

		setState( ! isOpen );
	} );
}

export function Disclosure() {
	document
		.querySelectorAll( '[data-accordion] [data-accordion-toggle]' )
		.forEach( ( button ) => bind( button, true ) );

	document
		.querySelectorAll( '[data-mobile-toggle]' )
		.forEach( ( button ) => bind( button, false ) );
}
